import { demoFile, component, componentWithVariants, variant, story, CLICK, INPUT } from 'system/demo';
import { AskMeAnythingLiveStatusWidget, AskMeAnythingStatusDescription } from 'open-modules/cbcrc/feature/topic/ask-me-anything-header';
import { PublicationStatusAdminScreen, TopicLiveStatusDescription, TopicLiveStatusWidget } from 'open-modules/cbcrc/feature/topic/live-status';

demoFile('open-modules/cbcrc/feature/topic/live-status');

componentWithVariants('AskMeAnythingLiveStatusWidget', AskMeAnythingLiveStatusWidget, {}, [
    variant('Live', { state: { globals: { endAt: '2030-01-01' } } }),
    variant('Closed', { state: { globals: { endAt: '2010-01-01' } } }),
    variant('Admin role', { state: { roles: ['Owner'], globals: { endAt: '2030-01-01' } } }, [
        story('Open admin panel', [CLICK('Edit live status (admin)')])
    ])
]);

component('AskMeAnythingStatusDescription', AskMeAnythingStatusDescription);

componentWithVariants('TopicLiveStatusWidget', TopicLiveStatusWidget, {}, [
    variant('Live', { state: { globals: { endAt: '2030-01-01' } } }),
    variant('Closed', { state: { globals: { endAt: '2010-01-01' } } }),
    variant('Admin role', { state: { roles: ['Owner'], globals: { endAt: '2030-01-01' } } }, [
        story('Open admin panel', [CLICK('Edit live status (admin)')])
    ])
]);

componentWithVariants('TopicLiveStatusDescription', TopicLiveStatusDescription, {}, [
    variant('Live', { state: { globals: { status: 'live' } } }),
    variant('Closed')
]);

componentWithVariants('PublicationStatusAdminScreen', PublicationStatusAdminScreen, {}, [
    variant('No access'),
    variant('Admin', { state: { roles: ['Owner'] } }, [
        story('Update live status', [
            INPUT('startsAt', '2022-01-01'),
            INPUT('endsAt', '2022-01-02'),
            CLICK('Update')
        ])
    ])
]);
